import React from 'react'

export default function UtilitiesInnerStyle({signed_in}) {
  let utilities_buttons = null
  if (signed_in !== 'admin') {
    utilities_buttons = {
      po_display: (signed_in.user_access.utilities_purchase_order) ? 'flex' : 'none',
      pobs_display: (signed_in.user_access.utilities_percent_off_batch_set) ? 'flex' : 'none',
      rpo_display: (signed_in.user_access.utilities_reset_percent_off) ? 'flex' : 'none'
    }
  } else utilities_buttons = { po_display: 'flex', pobs_display: 'flex', rpo_display: 'flex' }

  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        :root { --light: #555; }

        .utilities-container {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: 1fr;
          overflow: auto;
          padding: 0px 30px;
        }

        .utilities-item-wrapper {
          border: none;
          background-color: lightskyblue;
          display: flex;
          flex-direction: column;
          margin: 10px;
        }
        .utilities-item-title, .utilities-item-description {
          padding: 10px;
        }
        .utilities-item-title { font-size: 1.2rem; }
        .utilities-item-description {
          font-size: 0.95rem;
          color: var(--light, #555);
        }

        .utilities-item-wrapper:hover, .utilities-item-wrapper:focus {
          /* let's change the ---light here so settings-item-description is also affected by hover */
          transform: scale(1.0003);
          box-shadow: 1px 1px 2px 1px #BBB;
          border: none;
          background-color: blue;
          color: white;
          outline: none;
          --light: white;
        }

        /** Utilities Buttons **/
        #po-button { display: ${utilities_buttons.po_display}; }
        #percent-off-batch-set-button { display: ${utilities_buttons.pobs_display}; }
        #reset-percent-off-button { display: ${utilities_buttons.rpo_display}; }
      `}
      </style>
    </React.Fragment>
  )
}
